module.exports = __webpack_public_path__ + "static/Miller-Coors-2e6e3128206fe051ee87eab54cf3d76c.png";